import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { Download } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { exportContactsCsv } from '../../api/contacts'
import { downloadBlob, responseFilename } from '../../lib/download'

function buildExportParams({ stage, search, tag, tagId }) {
  return {
    stage,
    ...(String(search || '').trim() ? { search: String(search).trim() } : {}),
    ...(String(tag || '').trim() ? { tag: String(tag).trim() } : {}),
    ...(String(tagId || '').trim() ? { tag_id: String(tagId).trim() } : {}),
  }
}

export default function ExportContactsButton({
  tenantId,
  stage,
  search = '',
  tag = '',
  tagId = '',
  filenamePrefix = 'contacts',
}) {
  const { t } = useTranslation()
  const [exporting, setExporting] = useState(false)

  async function handleExport() {
    if (!tenantId || exporting) return
    setExporting(true)

    const params = buildExportParams({ stage, search, tag, tagId })
    try {
      const response = await exportContactsCsv(tenantId, params)
      const filename = responseFilename(
        response, `${filenamePrefix}-${stage}-${new Date().toISOString().slice(0, 10)}.csv`,
      )

      downloadBlob(response.data, filename)
      toast.success(t('contacts.exportSuccess'))
    } catch (err) {
      Sentry.captureException(err, {
        tags: { action: 'export_contacts_csv' },
        extra: { tenantId, params },
      })
      toast.error(t('contacts.exportFailed'))
    } finally {
      setExporting(false)
    }
  }

  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={!tenantId || exporting}
      className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-semibold text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <Download size={15} />
      <span>{exporting ? t('contacts.exporting') : t('contacts.export')}</span>
    </button>
  )
}
